import React from 'react'
import {Header, List} from 'semantic-ui-react'

const SimulateDelay = () => {
  return (
    <div className='doc-section'>
      <Header as='h2'>Simulate Delay</Header>
      <Header as='h3' dividing>Steps:</Header>
      <List relaxed>
        <List.Item>1. Navigate to the service/version/environment/resource you wish to work with.</List.Item>
        <List.Item>2. Click on the "Cog" icon and then the "Edit" icon for the response you want to script</List.Item>
        <List.Item>3. Click on "Settings" tab and toggle the "Scripted" option on.</List.Item>
        <List.Item>4. Enter an integer value of time in milliseconds you wish to delay the response by.</List.Item>
        <List.Item>5. Click the "Update" button</List.Item>
      </List>
    </div>
  )
}

export {SimulateDelay}

export default SimulateDelay